var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRetailWeb = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100pt",
    height: "100pt",
    viewBox: "0 0 152.000000 152.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,152.000000) scale(0.100000,-0.100000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 760 l0 -760 760 0 760 0 0 760 0 760 -760 0 -760 0 0 -760z m411   573 c28 -17 79 -101 79 -130 0 -7 -11 -13 -24 -13 -13 0 -37 -3 -53 -6 -27 -5   -32 -3 -41 25 -19 55 -88 60 -106 9 -17 -47 2 -80 99 -173 55 -52 101 -106   110 -127 19 -47 20 -130 1 -166 -55 -105 -206 -124 -288 -36 -26 28 -58 117   -46 129 3 3 28 8 57 12 44 5 51 3 51 -11 0 -31 30 -76 55 -82 16 -4 35 0 50   10 20 13 25 25 25 59 0 40 -4 46 -100 137 -58 56 -106 111 -115 132 -29 72   -14 169 33 211 53 48 151 56 213 20z m319 -323 l0 -340 -60 0 -60 0 0 340 0   340 60 0 60 0 0 -340z m334 143 c21 -106 41 -192 42 -190 2 2 15 57 29 123 14   65 32 152 41 192 l15 72 75 0 74 0 0 -340 0 -340 -50 0 -50 0 -1 258 -1 257   -51 -257 -51 -258 -27 0 c-33 0 -26 -22 -86 275 l-48 240 -3 -257 -2 -258 -50   0 -50 0 0 340 0 341 77 -3 77 -3 40 -192z m286 -582 c-64 -37 -964 -405 -1017   -416 -190 -40 -272 70 -185 248 30 60 131 183 116 142 -29 -86 -19 -153 29   -189 54 -40 118 -29 607 102 453 122 476 128 450 113z",
    fill: "#000000"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRetailWeb);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/retailWeb.003cafa5f3c867cebf352df2dae14acd.svg";